import { UserRound, BadgeCheck, ClipboardList, LayoutDashboard } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const POINTS = [
  {
    icon: UserRound,
    title: "Un interlocuteur dédié",
    text: "Une seule personne pour vous guider, répondre à vos questions et coordonner votre projet du début à la fin.",
  },
  {
    icon: BadgeCheck,
    title: "Des professionnels sélectionnés",
    text: "Nous vous mettons en relation avec des professionnels adaptés à votre projet et à votre secteur.",
  },
  {
    icon: ClipboardList,
    title: "Une visibilité claire à chaque étape",
    text: "Planning, étapes et documents regroupés : vous savez toujours où en est votre projet.",
  },
  {
    icon: LayoutDashboard,
    title: "Un espace de suivi du projet",
    text: "Suivez l'avancement de vos travaux, les jalons et les photos depuis votre espace client en ligne.",
  },
];

const TONES = ["bg-[#FDFBF7]", "bg-[#F6F1E8]", "bg-[#EFF3ED]", "bg-[#F8F0E9]"];

export const Trust = () => (
  <section id="apropos" data-testid="trust-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-cognac sm:text-sm">
          Pourquoi CozyHome
        </p>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
          Un accompagnement humain, du premier échange à la dernière finition.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {POINTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.08}>
            <article
              data-testid={`trust-point-${i}`}
              className={`h-full rounded-3xl p-8 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-sm ${TONES[i % TONES.length]}`}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-sage/15 text-sage">
                <p.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-6 text-base font-bold text-navy sm:text-lg">{p.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-stone-500">{p.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
